import { render } from "./AccountVerification.vue?vue&type=template&id=e37a49ec"
import script from "./AccountVerification.vue?vue&type=script&lang=js"
export * from "./AccountVerification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__